import clsx from "clsx";

export default function Container({ className, children }) {
  return (
    <div className={clsx("mx-auto w-full max-w-6xl px-5", className)}>
      {children}
    </div>
  );
}
